import { Link } from '@mui/material'
import { ReactNode } from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { AffectedKeyKind } from '../../interfaces/IAffectedEntitySearch'

interface EntityLinkProps {
  kind: AffectedKeyKind
  value: string
  children: ReactNode
  onNavigate?: () => void
}

export function EntityLink({ kind, value, children, onNavigate }: EntityLinkProps) {
  const target = `/?tab=search&type=${encodeURIComponent(kind)}&q=${encodeURIComponent(value)}`
  return (
    <Link
      component={RouterLink}
      to={target}
      onClick={onNavigate}
      underline="hover"
      sx={{ color: 'primary.main', cursor: 'pointer' }}
    >
      {children}
    </Link>
  )
}

export default EntityLink
